import {Injectable} from '@angular/core';
import {HealthCenterShort} from '../../../pages/health-center/services/http/health-center-short';

@Injectable()
export class HealthCentreService {

  constructor() {
  }

  public filterHealthCentreList(
    healthCentres: Array<HealthCenterShort>,
    filterValue: string,
  ): Array<HealthCenterShort> {
    return healthCentres.filter(
      (healthCentre: HealthCenterShort) => healthCentre.name.toLowerCase().includes(filterValue.toLowerCase()),
    );
  }
}
